"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M12.443 13.039h-1.02v-.87l.785-.535c.353-.242.572-.408.572-.8 0-.363-.258-.643-.737-.643-.557 0-.87.355-.87.899H10.2c0-1.156.808-1.79 1.851-1.79 1.176 0 1.749.733 1.749 1.51 0 .814-.599 1.201-1.072 1.506l-.042.028-.243.158v.537zM12.443 14.7h-1.02v-.982h1.02v.982z" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 12a6 6 0 1112 0 6 6 0 01-12 0zm6 5.1a5.1 5.1 0 110-10.2 5.1 5.1 0 010 10.2z" })), "GuidelineOutline");
//# sourceMappingURL=GuidelineOutline.js.map